/**
 * Script que:
 * 1. Encontra o ID de um vendedor da Webkul a partir da URL de uma página de perfil.
 * 2. Usa uma classe de codificação para transformar esse ID numérico em um código curto no formato LLN (ex: "AX0").
 * 3. Exibe o código gerado na página e no console.
 */

// PASSO 2: A classe para gerar o código, agora ajustada para o formato LLN (Letra-Letra-Número)
class SellerCodeGenerator {
  constructor() {
    // N é o número total de combinações possíveis: 26 letras * 26 letras * 10 números
    this.N = 26 * 26 * 10; // 6760 combinações

    // Constantes para a cifra afim. A deve ser coprimo de N.
    this.A = 101; // Escolhi um novo A que é coprimo do novo N.
    this.B = 12345;

    this.letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    // Pré-calcula o inverso modular de A para a decodificação
    this.A_inv = this.modInverse(this.A, this.N);
  }

  // --- Funções matemáticas auxiliares ---
  modInverse(a, m) {
    let m0 = m, x0 = 0, x1 = 1; a = ((a % m) + m) % m;
    if (m === 1) return 0;
    while (a > 1) { const q = Math.floor(a / m);[a, m] = [m, a % m];[x0, x1] = [x1 - q * x0, x0]; if (m === 0 && a !== 1) throw new Error("Inverso não existe."); }
    return (x1 + m0) % m0;
  }

  // --- Funções de empacotar/desempacotar para o formato LLN ---
  _unpack(codeNum) {
    const L1 = Math.floor(codeNum / (26 * 10)) % 26;
    const L2 = Math.floor(codeNum / 10) % 26;
    const N1 = codeNum % 10;
    return { L1, L2, N1 };
  }

  _pack({ L1, L2, N1 }) {
    return (L1 * 26 * 10) + (L2 * 10) + N1;
  }

  // --- Função principal de codificação ---
  encodeID(id) {
    id = Number(id);
    if (!Number.isInteger(id) || id < 0) throw new Error("ID inválido para codificação.");

    const idMod = id % this.N;
    const codeNum = (idMod * this.A + this.B) % this.N;
    const { L1, L2, N1 } = this._unpack(codeNum);

    return this.letters[L1] + this.letters[L2] + String(N1);
  }
}


// PASSO 1: A lógica que busca o ID do vendedor e depois chama o codificador
document.addEventListener('DOMContentLoaded', async () => {

  async function findAndEncodeSellerId() {
    // Verifica se estamos na página de perfil
    if (!window.location.pathname.includes('/pages/seller-profile')) return;

    // Extrai o handle do vendedor da URL
    const sellerHandle = window.location.search.substring(1);
    if (!sellerHandle) return;

    // Pega o nome da loja
    if (typeof Shopify === 'undefined' || !Shopify.shop) return;
    const shopName = Shopify.shop;

    // Monta a URL da API da Webkul
    const apiUrl = new URL('https://mvmapi.webkul.com/api/v2/public/sellers.json');
    apiUrl.searchParams.append('shop_name', shopName);
    apiUrl.searchParams.append('filter', `{"handle": "${sellerHandle}"}`);

    try {
      // Busca os dados do vendedor
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`Erro na API: ${response.statusText}`);
      const data = await response.json();

      // Verifica se um vendedor foi encontrado
      if (data.sellers && data.sellers.length > 0 && data.sellers[0].seller_id) {
        const sellerId = data.sellers[0].seller_id;
        console.log(`ID numérico do vendedor encontrado: ${sellerId}`);

        // PASSO 3: JUNTANDO TUDO
        // Cria uma instância do nosso codificador
        const coder = new SellerCodeGenerator();
        // Gera o código a partir do ID encontrado
        const sellerCode = coder.encodeID(sellerId);

        console.log(`✅ SUCESSO! O código gerado para o vendedor é: ${sellerCode}`);

        // Exibe o código na página (opcional)
        const displayElement = document.getElementById('seller-code-display');
        if (displayElement) {
          displayElement.textContent = `Código do Vendedor: ${sellerCode}`;
        }
        
      } else {
        console.log(`Nenhum vendedor encontrado com o handle "${sellerHandle}".`);
      }
    } catch (error) {
      console.error('Falha no processo:', error);
    }
  }

  // Inicia todo o processo
  findAndEncodeSellerId();
});